import { Component, Input, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TreeNode } from 'src/app/models';

@Component({
    selector: 'app-delete-category-dialog',
    templateUrl: './delete-category-dialog.component.html',
    styleUrls: ['./delete-category-dialog.component.scss'],
    standalone: false
})
export class DeleteCategoryDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<DeleteCategoryDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
      }

    closeDialog(): void {
        // Pass the undefined back to the parent component
        this.dialogRef.close();
    }

    deleteCategory(): void {
        // Pass the new node back to the parent component
        this.dialogRef.close({ id : this.data.id});
    }
}